import React, { useCallback, useEffect, useState } from 'react'
import { Card, CardContent, CardHeader, Box, TextField, Button } from "@mui/material"
import Typography from '@mui/material/Typography'
import DownloadIcon from '@mui/icons-material/Download';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { getWeekNumberCurrent } from "../../../helpers/utils"
import * as XLSX from 'xlsx';

//services
import SettleService from "../../../services/settle.service"
// import ConstService from "../../../services/const.service"

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const columns = [
    { field: 'id', headerName: 'ID', width: 60 },
    {
        field: 'weekNumber',
        headerName: '#Sem',
        width: 70,
        editable: false,
    },
    {
        field: 'invoiceNumber',
        headerName: '#Remisión',
        width: 90,
        editable: false,
    },
    {
        field: 'code',
        headerName: 'Código',
        width: 70,
        editable: false,
    },
    {
        field: 'reference',
        headerName: 'Referencia',
        width: 250,
        editable: false,
    },
    {
        field: 'amount',
        headerName: 'Cantidad',
        type: 'number',
        width: 90,
        editable: false,
    },
    {
        field: 'refWeight',
        headerName: 'Peso Referencia',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'weightInvoice',
        headerName: 'Peso Remisión',
        type: 'number',
        width: 170,
        editable: false,
    },
    {
        field: 'canTon',
        headerName: 'Peso Calculado',
        type: 'number',
        width: 170,
        editable: false,
    },
    {
        field: 'totalCanTon',
        headerName: 'Peso Basculado',
        type: 'number',
        width: 160,
        editable: false,
    },
    {
        field: 'price',
        headerName: 'Precio Cliente',
        type: 'number',
        width: 130,
        editable: false,
    },
    {
        field: 'totalClientPrice',
        headerName: 'Precio Total Cliente',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'modalidad',
        headerName: 'Modalidad',
        width: 120,
        editable: false,
    },
    {
        field: 'pricecontractor',
        headerName: 'Precio Contratista',
        type: 'number',
        width: 150,
        editable: false,
    }
    ,
    {
        field: 'pricecontractortotal',
        headerName: 'Precio Total Contratista',
        type: 'number',
        width: 170,
        editable: false,
    }
]

const columnsCustomer = [
    { field: 'id', headerName: 'ID', width: 60 },
    {
        field: 'weekNumber',
        headerName: '#Sem',
        width: 70,
        editable: false,
    },
    {
        field: 'invoiceNumber',
        headerName: '#Remisión',
        width: 90,
        editable: false,
    },
    {
        field: 'customerName',
        headerName: 'Nombre del cliente',
        width: 180,
        editable: false,
    },
    {
        field: 'customerIdentification',
        headerName: 'Identificación cliente',
        width: 150,
        editable: false,
    },
    {
        field: 'type',
        headerName: 'Tipo',
        width: 120,
        editable: false,
    },
    {
        field: 'canTon',
        headerName: 'Peso Calculado',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'totalCanTon',
        headerName: 'Peso Basculado',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'amount',
        headerName: 'Cant X Precio',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'priceCustomer',
        headerName: 'Precio Cliente',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'totalClientPrice',
        headerName: 'Precio Total Cliente',
        type: 'number',
        width: 150,
        editable: false,
    }
]

const columnsContractor = [
    { field: 'id', headerName: 'ID', width: 60 },
    {
        field: 'weekNumber',
        headerName: '#Sem',
        width: 70,
        editable: false,
    },
    {
        field: 'invoiceNumber',
        headerName: '#Remisión',
        width: 90,
        editable: false,
    },
    {
        field: 'contractorName',
        headerName: 'Nombre del contratista',
        width: 180,
        editable: false,
    },
    {
        field: 'modalidad',
        headerName: 'Modalidad',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'totalCanTon',
        headerName: 'Peso',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'contractorPrice',
        headerName: 'Precio Unidad',
        type: 'number',
        width: 150,
        editable: false,
    },
    {
        field: 'totalContractorPrice',
        headerName: 'Precio Total Contratista',
        type: 'number',
        width: 150,
        editable: false,
    }
]

const SettleReport = () => {
    const [value, setValue] = React.useState(0);

    const [loading, setLoading] = React.useState(false)
    const [settles, setSettles] = React.useState([])
    const [settlesCustomer, setSettlesCustomer] = React.useState([])
    const [settlesContractor, setSettlesContractor] = React.useState([])
    const [error, setError] = React.useState(null)
    const [week, setWeek] = React.useState("")
    const [year, setYear] = React.useState(new Date().getFullYear().toString())

    //Functions
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const fetchReportSettlesHandler = React.useCallback(async () => {
        setLoading(true)
        setError(null)
        if (week) {
            try {
                const settlesList = await SettleService.getReportSettles(week, year)

                const newSettle = settlesList.map((settle, index) => {

                    // RF01: Ajuste de fórmula de cálculo según tipo de producto
                    let totalClientPrice;
                    if (settle.type === 'Pulpa' || settle.type === 'Pulpa seleccionada' || settle.type === 'Rolo') {
                        // Para pulpa, pulpa seleccionada y rolo: CustomerPrice * totalCanTon
                        totalClientPrice = settle.CustomerPrice * settle.totalCanTon;
                    } else {
                        // Para todos los demás: CustomerPrice * amount (cálculo normal)
                        totalClientPrice = settle.CustomerPrice * settle.amount;
                    }

                    let data = {
                        id: index,
                        weekNumber: settle.weekNumber,
                        invoiceNumber: settle.invoiceNumber,
                        code: settle.code,
                        reference: settle.name,
                        amount: settle.amount,
                        refWeight: settle.refWeight,
                        weightInvoice: settle.weightInvoice,
                        canTon: settle.canTon,
                        totalCanTon: settle.totalCanTon,
                        price: settle.CustomerPrice,
                        totalClientPrice: totalClientPrice,
                        modalidad: settle.modalidad === "contractorPriceTalarasa" ? "Talarasa" : "Entresaca",
                        pricecontractor: settle.modalidad === "contractorPriceTalarasa" ? settle.contractorPriceTalarasa : settle.contractorPriceEntresaca,
                        pricecontractortotal: (settle.totalCanTon * (settle.modalidad === "contractorPriceTalarasa" ? settle.contractorPriceTalarasa : settle.contractorPriceEntresaca))
                    }
                    return data
                })

                setSettles(newSettle)
                setLoading(false);

            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
            //warnin this value of callback
            //||
            //\/
        }
    }, [week, year]);

    const getReportSettleByCustomer = useCallback(async () => {
        setLoading(true)
        setError(null)
        if (week) {
            try {
                const settlesList = await SettleService.getReportSettleByCustomers(week, year)
                const newSettle = settlesList.map((settle, index) => {

                    let totalClientPrice;
                    if (settle.type === 'Pulpa' || settle.type === 'Pulpa seleccionada' || settle.type === 'Rolo') {
                        totalClientPrice = settle.CustomerPrice * settle.totalCanTon;
                    } else {
                        totalClientPrice = settle.CustomerPrice * settle.amount;
                    }

                    let data = {
                        id: index,
                        weekNumber: settle.weekNumber,
                        invoiceNumber: settle.invoiceNumber,
                        customerName: settle.customerName,
                        customerIdentification: settle.customerIdentification,
                        type: settle.type,
                        canTon: settle.canTon,
                        totalCanTon: settle.totalCanTon,
                        amount: settle.amount,
                        priceCustomer: settle.CustomerPrice,
                        totalClientPrice: totalClientPrice,
                    }
                    return data
                })
                setSettlesCustomer(newSettle)
                setLoading(false)
            } catch (error) {
                setError(error.message);
                setLoading(false)
            }
        }
    }, [week, year])

    const getReportSettleByContractor = useCallback(async () => {
        setLoading(true)
        setError(null)
        if (week) {
            try {
                const settlesList = await SettleService.getReportSettleByContractor(week, year)
                const newSettle = settlesList.map((settle, index) => {

                    let data = {
                        id: index,
                        weekNumber: settle.weekNumber,
                        invoiceNumber: settle.invoiceNumber,
                        contractorName: settle.contractorName,
                        modalidad: settle.modalidad === "contractorPriceTalarasa" ? "Talarasa" : "Entresaca",
                        totalCanTon: settle.totalCanTon,
                        contractorPrice: settle.modalidad === "contractorPriceTalarasa" ? settle.contractorPriceTalarasa : settle.contractorPriceEntresaca,
                        totalContractorPrice: (settle.totalCanTon * (settle.modalidad === "contractorPriceTalarasa" ? settle.contractorPriceTalarasa : settle.contractorPriceEntresaca)),
                    }
                    return data
                })
                setSettlesContractor(newSettle)
                setLoading(false)
            } catch (error) {
                setError(error.message);
                setLoading(false)
            }
        }
    }, [week, year])

    const findSettlesData = () => {
        fetchReportSettlesHandler()
    }

    const findSettleCustomerdata = () => {
        getReportSettleByCustomer()
    }

    const findSettleContractordata = () => {
        getReportSettleByContractor()
    }

    // Funciones de exportación XLSX
    const exportToXLSX = (data, fileName) => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    }

    const exportGeneralToXLSX = () => {
        if (settles.length === 0) {
            alert('No hay datos para exportar');
            return;
        }
        exportToXLSX(settles, `reporte_general_semana_${week}_año_${year}`);
    }

    const exportCustomerToXLSX = () => {
        if (settlesCustomer.length === 0) {
            alert('No hay datos para exportar');
            return;
        }
        exportToXLSX(settlesCustomer, `reporte_clientes_semana_${week}_año_${year}`);
    }

    const exportContractorToXLSX = () => {
        if (settlesContractor.length === 0) {
            alert('No hay datos para exportar');
            return;
        }
        exportToXLSX(settlesContractor, `reporte_contratistas_semana_${week}_año_${year}`);
    }

    React.useEffect(() => {
        void setWeek(getWeekNumberCurrent())
    }, [])

    return (
        <div>
            <Card>
                <CardHeader
                    title={
                        <Typography variant='h5'>
                            Reportes de liquidaciones
                        </Typography>
                    }
                ></CardHeader>
                <Box sx={{ width: '97%', borderBottom: '1px solid #DEDEDE', margin: '0 auto' }} />
                <Box sx={{ width: '97%', borderBottom: '1px solid #DEDEDE', margin: '0 auto' }}>{error}</Box>
                <CardContent>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="Reporte General" {...a11yProps(0)} />
                                <Tab label="Reporte por Contratista" {...a11yProps(1)} />
                                <Tab label="Reporte por cliente" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <Box
                                sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                            >
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        id={'week'}
                                        name={'week'}
                                        label={'Semana del año'}
                                        variant="outlined"
                                        value={week}
                                        onChange={(e) => { setWeek(e.target.value) }}
                                    />
                                    <TextField
                                        id={'year'}
                                        name={'year'}
                                        label={'Año'}
                                        variant="outlined"
                                        value={year}
                                        onChange={(e) => { setYear(e.target.value) }}
                                        sx={{ width: 800 }}
                                    />
                                    <Button variant="contained" onClick={() => { findSettlesData() }} sx={{ height: 56, minWidth: 110 }}>Consultar</Button>
                                    <Button
                                        variant="outlined"
                                        onClick={exportGeneralToXLSX}
                                        disabled={settles.length === 0}
                                        sx={{
                                            height: 56,
                                            minWidth: 56,
                                            padding: 0,
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <DownloadIcon />
                                    </Button>
                                </Box>
                                <Box sx={{ height: 430, width: '100%', mt: 3 }}>
                                    <DataGrid
                                        rows={settles}
                                        columns={columns}
                                        loading={loading}
                                        components={{ Toolbar: GridToolbar }}
                                        pageSize={5}
                                        rowsPerPageOptions={[5]}
                                        disableSelectionOnClick
                                        experimentalFeatures={{ newEditingApi: true }}
                                    />
                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Box
                                sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                            >
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        id={'week'}
                                        name={'week'}
                                        label={'Semana del año'}
                                        variant="outlined"
                                        value={week}
                                        onChange={(e) => { setWeek(e.target.value) }}
                                    />
                                    <TextField
                                        id={'year'}
                                        name={'year'}
                                        label={'Año'}
                                        variant="outlined"
                                        value={year}
                                        onChange={(e) => { setYear(e.target.value) }}
                                        sx={{ width: 800 }}
                                    />
                                    <Button variant="contained" onClick={() => { findSettleContractordata() }} sx={{ height: 56, minWidth: 110 }}>Consultar</Button>
                                    <Button
                                        variant="outlined"
                                        onClick={exportContractorToXLSX}
                                        disabled={settlesContractor.length === 0}
                                        sx={{
                                            height: 56,
                                            minWidth: 56,
                                            padding: 0,
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <DownloadIcon />
                                    </Button>
                                </Box>
                                <Box sx={{ height: 430, width: '100%', mt: 3 }}>
                                    <DataGrid
                                        rows={settlesContractor}
                                        columns={columnsContractor}
                                        loading={loading}
                                        components={{ Toolbar: GridToolbar }}
                                        pageSize={5}
                                        rowsPerPageOptions={[5]}
                                        disableSelectionOnClick
                                        experimentalFeatures={{ newEditingApi: true }}
                                    />
                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Box
                                sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                            >
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        id={'week'}
                                        name={'week'}
                                        label={'Semana del año'}
                                        variant="outlined"
                                        value={week}
                                        onChange={(e) => { setWeek(e.target.value) }}
                                    />
                                    <TextField
                                        id={'year'}
                                        name={'year'}
                                        label={'Año'}
                                        variant="outlined"
                                        value={year}
                                        onChange={(e) => { setYear(e.target.value) }}
                                        sx={{ width: 800 }}
                                    />
                                    <Button variant="contained" onClick={() => { findSettleCustomerdata() }} sx={{ height: 56, minWidth: 110 }}>Consultar</Button>
                                    <Button
                                        variant="outlined"
                                        onClick={exportCustomerToXLSX}
                                        disabled={settlesCustomer.length === 0}
                                        sx={{
                                            height: 56,
                                            minWidth: 56,
                                            padding: 0,
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <DownloadIcon />
                                    </Button>
                                </Box>
                                <Box sx={{ height: 430, width: '100%', mt: 3 }}>
                                    <DataGrid
                                        rows={settlesCustomer}
                                        columns={columnsCustomer}
                                        loading={loading}
                                        components={{ Toolbar: GridToolbar }}
                                        pageSize={5}
                                        rowsPerPageOptions={[5]}
                                        disableSelectionOnClick
                                        experimentalFeatures={{ newEditingApi: true }}
                                    />
                                </Box>
                            </Box>
                        </TabPanel>
                    </Box>
                </CardContent>
            </Card>
        </div>
    )
}

export default SettleReport